import React from 'react';
import {Formik} from 'formik';
import {
    withStyles,
    TextField,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
} from '@material-ui/core';
import {Row, Col} from 'react-flexbox-grid';
import PropTypes from 'prop-types';

const styles = theme => ({
    textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit
    },
    button: {
      margin: theme.spacing.unit * 2,
    },
    panel : {
      marginLeft : 12
    },
    root : {
        margin : 12
    },
    actions : {
        marginRight : 4
    },
    buttonFile : {
        marginLeft : 12,
        marginTop : 12
    }
});

/**
 * Componente para agregar o actualizar un Tag
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const TagsAddForm = ({
    classes, 
    open, 
    onSubmit, 
    objectEdit, 
    onClose,
}) => {
    return(
        <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{!objectEdit ? 'Agregar tag' : 'Actualizar tag'}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={{
                        name        : objectEdit ? objectEdit.name : '',
                        description : objectEdit ? objectEdit.description : '',
                    }}
                    validate={values => {
                        let errors = {};
                        if (!values.name) {
                          errors.name = "Requerido";
                        }
                        return errors;
                    }}
                    onSubmit={(values, bag) => {
                        onSubmit({
                            variables: {
                                id  : objectEdit ? objectEdit.id : null, 
                                tag : {name: values.name, description: values.description}
                            }
                        }).then(() => {
                          bag.setSubmitting(false);
                        });
                    }}
                >
                    {({
                        values,
                        errors,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                    }) => {
                        return(
                            <form autoComplete="off" onSubmit={handleSubmit}>
                                <Row style={{ marginRight: 10 }}>
                                    <Col xs={12} md={12}>
                                        <TextField
                                            required
                                            name      = "name"
                                            id        = "outlined-name"
                                            label     = "Nombre"
                                            margin    = "normal"
                                            variant   = "outlined"
                                            className = {classes.textField}
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            value    = {values.name}
                                            onChange = {handleChange}
                                            error    = {Boolean(errors.name)}
                                        />
                                    </Col>
                                    <Col xs={12} md={12}>
                                        <TextField
                                            name      = "description"
                                            id        = "outlined-name"
                                            label     = "Descripción"
                                            margin    = "normal"
                                            variant   = "outlined"
                                            className = {classes.textField}
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            value    = {values.description}
                                            onChange = {handleChange}
                                        />
                                    </Col>
                                </Row>
                                <Row end="xs" className={classes.actions}>
                                    <Col xs>
                                        <Button 
                                            onClick   = {onClose} 
                                            color     = "inherit" 
                                            variant   = "contained" 
                                            className = {classes.button}
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            color    = "primary" 
                                            variant  = "contained"
                                            type     = "submit"
                                            disabled = {isSubmitting}
                                        >
                                            {!objectEdit ? 'Agregar' : 'Actualizar'}
                                        </Button>
                                    </Col>
                                </Row>
                            </form>
                        )
                    }}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

TagsAddForm.propTypes = {
    classes    : PropTypes.object, 
    open       : PropTypes.bool, 
    onSubmit   : PropTypes.func, 
    objectEdit : PropTypes.object, 
    onClose    : PropTypes.func,
}

export default withStyles(styles)(TagsAddForm);


// WEBPACK FOOTER //
// ./src/components/tags-manager/resources-tags/tagsAddForm.js